import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AreaService } from 'src/app/area/area.service';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { MembersService } from 'src/app/members/members.service';
import { Area } from 'src/app/shared/interfaces/area.interface';
import { Sector } from 'src/app/shared/interfaces/sector.interface';
import { SectorService } from '../sector.service';

@Component({
  selector: 'app-sector-form',
  templateUrl: './sector-form.component.html',
  styleUrls: ['./sector-form.component.css'],
})
export class SectorFormComponent implements OnInit {
  form: FormGroup;
  id: number;
  options: string[] = ['One', 'Two', 'Three'];
  members: [];
  sector: Sector;
  areas: [];
  leader: any;
  constructor(
    private memberService: MembersService,
    private toater: ToastrService,
    private sectorService: SectorService,
    private areaService: AreaService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private loadService: LoaderService
  ) {}

  ngOnInit(): void {
    this.activatedRouter.params.subscribe((params) => {
      this.id = params.id;
    });
    if (this.id) {
      this.getSector();
    }

    this.getMembers();
    this.getAeras();

    this.form = new FormGroup({
      name: new FormControl('', [Validators.minLength(6), Validators.required]),
      leader_id: new FormControl('', [Validators.required, Validators.minLength(1)]),
      area_id: new FormControl('', [Validators.required, Validators.minLength(1)]),
    });
  }

  getMembers(): Promise<any> {
    return this.memberService
      .get({ page: 1, limit: 10 })
      .then((res) => {
        this.members = res.data;
      })
      .catch((err) => {
        this.toater.error(err.messsage || 'Falha ao carregar membros!');
      });
  }

  getSector() {
    this.loadService.showLoader();
    this.sectorService
      .getById(this.id)
      .then((res) => {
        this.sector = res;
        this.form.setValue({
          name: res.name,
          leader_id: res.leader_id,
          area_id: res.area_id,
        });
        this.leader = res.leader;
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.toater.error(err.messsage || 'Falha ao carregar setor!');
        this.loadService.closeLoader();
      });
  }

  save(): Promise<void> {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    this.sectorService
      .updateSector(this.form.value, this.id)
      .then((res) => {
        this.toater.success(res.message);
        this.router.navigateByUrl('/setor');
      })
      .catch((err) => {
        this.toater.error(err.error.message || 'Falha ao salvar setor!');
      });
  }

  add(): Promise<any> {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    return this.sectorService
      .addSector(this.form.value)
      .then((res) => {
        this.toater.success(res.message);
        this.router.navigateByUrl('/setor');
      })
      .catch((err) => {
        this.toater.error(err.error.message || 'Falha ao salvar setor!');
      });
  }

  getAeras(): Promise<any> {
    return this.areaService
      .get()
      .then((res) => {
        this.areas = res;
      })
      .catch((err) => {
        this.toater.error(err.error.message || 'Algo de errado aconteceu !');
      });
  }

  findByCECID(CECID: any) {
    this.memberService.getByCECID(CECID).then((res) => {
      this.leader = res[0];
    });
  }

  clearLeader() {
    this.leader = {};
    this.form.get('leader_id').reset();
  }
}
